import styled, { css } from 'styled-components';

const BorderBox = styled.div<{ $hasErrors?: boolean }>`
  --border-box-horizontal-padding: 6px;

  box-sizing: border-box;
  width: 100%;
  background: var(--color-input-background);
  border: var(--border-input);
  border-radius: var(--border-radius-input);
  padding: 0 var(--border-box-horizontal-padding);
  ${({ $hasErrors }) => $hasErrors && css`
    border-color: var(--color-error);
  `}

  &:focus-within {
    outline: var(--outline-input-focus);
  }
`;

export default BorderBox;
